import React from "react";
import InputFile from "../InputFile";

function InputFileMultiple({
  className,
  value = [],
  onChange,
  saveFile,
  ...props
}) {
  return (
    <InputFile
      className={className}
      value={value}
      onChange={onChange}
      saveFile={saveFile}
      multiple
      {...props}
    />
  );
}

export default InputFileMultiple;
